import { motion } from "framer-motion";
import { fadeUp, stagger } from "./motion";

const flow = [
  { pct: "BUY", label: "Community buys $AHHH Screaming Chicken on pump.fun", color: "#39ff14" },
  { pct: "FUEL", label: "Liquidity & treasury grow the mission war-chest", color: "#00f0ff" },
  { pct: "BUILD", label: "Funds deploy to crisis accommodation & outreach", color: "#ffb800" },
  { pct: "REPORT", label: "Impact receipts published back to the flock", color: "#ff007f" },
];

export const Tokenomics = () => {
  return (
    <section id="tokenomics" className="relative py-24 sm:py-32 px-5 sm:px-6 border-t border-white/10" data-testid="tokenomics-section">
      <div className="max-w-7xl mx-auto">
        <div className="max-w-2xl mb-14">
          <div className="font-mono text-xs uppercase tracking-[0.3em] text-[#ffb800] mb-4">How buys fuel the mission</div>
          <h2 className="font-display font-black uppercase tracking-tighter leading-none text-4xl sm:text-5xl lg:text-6xl">
            Every buy is a brick.
          </h2>
        </div>

        <motion.div
          variants={stagger}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.2 }}
          className="grid grid-cols-1 md:grid-cols-4 gap-5"
        >
          {flow.map((f, i) => (
            <motion.div
              key={i}
              variants={fadeUp}
              className="relative rounded-2xl border border-white/10 bg-[#101010] p-7 min-h-[200px] flex flex-col justify-between"
              data-testid={`tokenomics-step-${i}`}
            >
              <span className="font-mono text-xs text-white/40">STEP {i + 1}</span>
              <div>
                <div className="font-display font-black text-2xl mb-2" style={{ color: f.color }}>{f.pct}</div>
                <p className="font-mono text-sm text-white/55 leading-relaxed">{f.label}</p>
              </div>
              <div className="absolute top-6 right-6 w-2 h-2 rounded-full" style={{ background: f.color }} />
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
